<div class="row">
  <queoval-stage-questionnaires-affectation class="col-xl-4 col-lg-6 col-12"></queoval-stage-questionnaires-affectation>
  <div class="col-xl-8 col-lg-6 col-12"><q-quest-result [ModeQuest]="'QuestFromStageERP'" [IdStage]="service.Stage.Ident"></q-quest-result></div>

</div>


